export default __webpack_public_path__ + "static/media/features.2.977154c7.svg";